function setUpClickListener() {
    const reviewLink = document.querySelector('.lipscore-rating-review-link');

    reviewLink.removeEventListener('click', handleReviewLinkClick);
    reviewLink.addEventListener('click', handleReviewLinkClick);
}

function handleReviewLinkClick(e) {
    e.preventDefault(); // Prevent the default link action

    let accordions = [...document.querySelectorAll('.product-details__block .disclosure--row')];

    if (!accordions || accordions.length === 0) {
    return;
    }

    let reviewsAccordion = accordions.filter(el => el.textContent.toLowerCase().includes('reviews'));

    if (!reviewsAccordion || reviewsAccordion.length === 0) {
    return;
    }
    
    reviewsAccordion = reviewsAccordion[0];
    
    if (reviewsAccordion.hasAttribute( 'open' ) == false ) {
    reviewsAccordion.querySelector( 'summary' ).click();

    setTimeout(() => {
        document.querySelector('.lipscore-rating-review-link').click();
    }, 300);
    }
}

const intervalID = setInterval(() => {
    if (document.querySelector('.lipscore-rating-review-link')) {
    clearInterval(intervalID); 
    setUpClickListener();
    }
}, 100); // Check every 100ms
